import type { FormDataType } from 'integrations/types';

import type { OnePasswordGenericInputCreateRequest, OnePasswordInputCreateRequest } from './types';

export const toOnePasswordInputCreateRequest = ({
  apiToken,
  endPoint,
  onePasswordName,
  onePasswordStoreFullMessage,
  onePasswordThrottleEnabled,
  pollingInterval,
  contentTypes,
  overrideSource,
}: FormDataType): OnePasswordInputCreateRequest => ({
  name: onePasswordName.value,
  polling_interval: pollingInterval.value,
  api_token: apiToken.value,
  store_full_message: onePasswordStoreFullMessage.value,
  enable_throttling: !!onePasswordThrottleEnabled?.value,
  end_point: endPoint.value,
  content_type: contentTypes.value.split(','),
  override_source: overrideSource.value,
});

export const toGenericInputCreateRequest = ({
  apiToken,
  endPoint,
  onePasswordName,
  onePasswordStoreFullMessage,
  onePasswordThrottleEnabled,
  pollingInterval,
  contentTypes,
  overrideSource,
}: FormDataType): OnePasswordGenericInputCreateRequest => ({
  type: 'org.graylog.enterprise.integrations.onepassword.OnePasswordInput',
  title: onePasswordName.value,
  global: false,
  configuration: {
    polling_interval: pollingInterval.value,
    api_token: apiToken.value,
    end_point: endPoint.value,
    throttling_allowed: !!onePasswordThrottleEnabled?.value,
    store_full_message: onePasswordStoreFullMessage.value,
    content_type: contentTypes.value.split(','),
    override_source: overrideSource.value,
  },
});
